import React from "react";
import { useTranslation } from "react-i18next";

const PurchaseFormItemsSummaryTableHeader = () => {
	const { t } = useTranslation();

	return (
		<thead>
			<tr>
				<th>{t("modules.purchase.field.price_net.title")}</th>
				<th>
					{t("common.word.vat_rate")} {t("common.word.vat")}
				</th>
				<th>{t("modules.purchase.field.price_vat.title")}</th>
				<th colSpan={2}>{t("modules.purchase.field.price_gross.title")}</th>
			</tr>
		</thead>
	);
};

export default PurchaseFormItemsSummaryTableHeader;
